<template>
	<div>
		<div class="filter-group-frame box-size">

		</div>
	</div>
	
</template>
<script>
export default {
	props:{

	},
	data : function(){
		return{

		}
	}
}
</script>
<style>
.filter-group-frame{
	border: 1px;
	border-radius: 2px;
	border-color: blackf;
	border-style: solid;
}
.box-size{
	width: 200px;
	height: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/automation/FilterGroup.vue